import React from 'react';
import './header.scss';
import logo from '../assets/img/logo-rimac.svg';
import icoPhone from '../assets/img/ico-phone.svg';

export const Header = () => {
  return (
    <header>
      <div className="container">
        <div className="logo">
            <img src={logo} alt="Rimac" />
        </div>
        <div className="contacto">
            <div className="txt">
                ¡Compra por este medio!
            </div>
            <div className="telefono">
                <img src={icoPhone} alt="phone" />
                (01) 411 6001
            </div>
        </div>
    </div> 
				
	

				
	

    </header>
  )
}
